(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").off("click.productAccordion").on("click.productAccordion", function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});

		document.querySelectorAll(".read-more-button").forEach((button) => {
			if (button.dataset.readMoreBound === "true") return;
			button.dataset.readMoreBound = "true";
			button.addEventListener("click", function (e) {
				e.preventDefault();
				const href = this.getAttribute("href");
				if (!href) return;
				const target = document.querySelector(href);
				if (!target) return;
				const toggle = target.querySelector(".about__accordion-toggle");
				const description = target.querySelector(".about__accordion-description");
				if (toggle && !toggle.classList.contains("active")) {
					toggle.classList.add("active");
					if (description) $(description).stop().slideDown(300);
				}
				target.scrollIntoView({ behavior: "smooth", block: "start" });
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
